import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Regimen } from '@cureskin/api-client/src/server-api';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { ShopService } from '@services/shop-service/shop.service';

@Component({
  selector: 'app-buy-complete-kit-banner',
  standalone: true,
  imports: [ButtonCtaComponent],
  templateUrl: './buy-complete-kit-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyCompleteKitBannerComponent {
  private readonly shopService = inject(ShopService);

  regimen = input<Regimen | null>(null);
  buyKit = output<Regimen>();

  discount = computed(() => this.shopService.getDiscountPercent(this.regimen()));

  onBuyKit(): void {
    const reg = this.regimen();
    if (!reg) return;
    this.buyKit.emit(reg);
  }
}
